import API from '~/api';

export default function ({ redirect }) {
  // If the user is not authenticated
  if (API.credentials.login) {
    redirect({ name: 'agenlite_apps_lite_homepage' });
  }
}
